import React from "react";
import "../HomeAbout.css";
import { Link } from "react-router-dom";

import heroImage from "../../assets/banner-6.jfif";

import {
    FiArrowRight,
    FiShield,
    FiLayers,
    FiCpu,
    FiCheckCircle,
    FiClock,
} from "react-icons/fi";

const HomeAbout = () => {
    return (
        <section className="home-about">

            <div className="container">

                {/* ===========================
              SECTION HEADING
        =========================== */}

                <div className="section-heading">

                    <span className="section-tag">
                        WHO WE EMPOWER
                    </span>

                    <h2>
                        Driving the Next Generation of
                        <span> Financial Innovation</span>
                    </h2>

                    <p>
                        Saivari Fintech Private Limited enables banks, NBFCs,
                        payment providers, fintech startups, and financial
                        institutions with secure, scalable, and compliant
                        auxiliary technology services that accelerate digital
                        transformation and business growth.
                    </p>

                </div>

                {/* ===========================
                CONTENT
        =========================== */}

                <div className="about-wrapper">

                    {/* LEFT */}

                    <div className="about-image">

                        <div className="home-dashboard-card">

                            <div className="home-dashboard-header">
                                <span className="dot blue"></span>
                                <span className="dot green"></span>
                                <span className="dot orange"></span>
                            </div>

                            <h4>FinTech Operations Dashboard</h4>

                            <div className="home-dashboard-chart">
                                <div className="bar b1"></div>
                                <div className="bar b2"></div>
                                <div className="bar b3"></div>
                                <div className="bar b4"></div>
                                <div className="bar b5"></div>
                            </div>

                            <div className="home-dashboard-stats">

                                <div className="home-dashboard-box">
                                    <h5>99.99%</h5>
                                    <span>System Availability</span>
                                </div>

                                <div className="home-dashboard-box">
                                    <h5>256-bit</h5>
                                    <span>Encryption</span>
                                </div>

                            </div>

                        </div>

                        <div className="kpi-card payment">
                            <span>💳</span>
                            <div>
                                <h4>Digital Payments</h4>
                                <p>Fast & Secure</p>
                            </div>
                        </div>

                        <div className="kpi-card security">
                            <span>🛡️</span>
                            <div>
                                <h4>Security Score</h4>
                                <p>Enterprise Grade</p>
                            </div>
                        </div>

                        <div className="kpi-card analytics">
                            <span>📈</span>
                            <div>
                                <h4>Analytics</h4>
                                <p>Real-time Insights</p>
                            </div>
                        </div>

                        {/* <div className="kpi-card automation">
                            <span>📑</span>
                            <div>
                                <h4>KYC Verification</h4>
                                <p>Fast & Secure Onboarding</p>
                            </div>
                        </div> */}

                        <div className="kpi-card api">
                            <span>🔒</span>
                            <div>
                                <h4>Fraud Prevention</h4>
                                <p>Advanced Risk Monitoring</p>
                            </div>
                        </div>

                    </div>

                    {/* RIGHT */}

                    <div className="about-content">

                        <span className="about-small-title">
                            YOUR TRUSTED FINTECH PARTNER
                        </span>

                        <h3>
                            Helping Financial Businesses Build Smarter
                            Digital Ecosystems
                        </h3>

                        <p>
                            We combine technology expertise, operational
                            excellence, and regulatory understanding to
                            deliver innovative auxiliary fintech services.
                            Our solutions simplify financial operations,
                            improve customer experiences, strengthen
                            security, and enable sustainable business
                            growth.
                        </p>

                        {/* FEATURES */}

                        <div className="about-features">

                            <div className="feature-card">

                                <div className="feature-icon">
                                    <FiShield />
                                </div>

                                <div>
                                    <h4>Enterprise Security</h4>
                                    <p>
                                        Advanced protection for modern financial
                                        platforms.
                                    </p>
                                </div>

                            </div>

                            <div className="feature-card">

                                <div className="feature-icon">
                                    <FiLayers />
                                </div>

                                <div>
                                    <h4>Compliance First</h4>
                                    <p>
                                        Built with regulatory compliance and trust
                                        in mind.
                                    </p>
                                </div>

                            </div>

                            <div className="feature-card">

                                <div className="feature-icon">
                                    <FiCpu />
                                </div>

                                <div>
                                    <h4>KYC Verification</h4>
                                    <p>
                                        Fast & Secure Onboarding
                                    </p>
                                </div>

                            </div>

                            <div className="feature-card">

                                <div className="feature-icon">
                                    <FiClock />
                                </div>

                                <div>
                                    <h4>24/7 Business Support</h4>
                                    <p>
                                        Dedicated assistance whenever your business
                                        needs it.
                                    </p>
                                </div>

                            </div>

                        </div>

                        {/* CHECK LIST */}

                        {/* <div className="about-list">

                            <div>
                                <FiCheckCircle />
                                Secure Infrastructure
                            </div>

                            <div>
                                <FiCheckCircle />
                                Cloud Native Solutions
                            </div>

                            <div>
                                <FiCheckCircle />
                                Scalable Architecture
                            </div>

                            <div>
                                <FiCheckCircle />
                                Business Automation
                            </div>

                        </div> */}

                        {/* BUTTON */}

                        <a
                            href="/about"
                            className="about-btn"
                        >
                            Discover More
                            <FiArrowRight />
                        </a>

                    </div>

                </div>

            </div>

        </section>
    );
};

export default HomeAbout;